import { render } from "./Section.vue?vue&type=template&id=b4987194&scoped=true&ts=true"
import script from "./Section.vue?vue&type=script&lang=ts"
export * from "./Section.vue?vue&type=script&lang=ts"

import "./Section.vue?vue&type=style&index=0&id=b4987194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4987194"]])

export default __exports__